import type { PdsOrder, PdsOrderItem } from '../types';

const MINUTE = 60_000;

const item = (
  id: string,
  quantity: number,
  name: string,
  prepared = false,
  option?: string,
): PdsOrderItem => ({ id, quantity, name, option, prepared });

// Les échéances sont relatives à `now` pour que le tableau garde toujours la
// même allure (3 commandes en retard) quelle que soit l'heure d'ouverture.
export const buildSeedOrders = (now: number): PdsOrder[] => {
  const due = (offsetMinutes: number) => now + offsetMinutes * MINUTE;

  return [
    {
      id: 'o-113',
      number: 113,
      label: '+32 471 09 55 12',
      contact: { phone: '+32 471 09 55 12' },
      channel: 'Click & Collect',
      pickupCode: '4 1 7 2',
      dueAt: due(-16),
      stage: 'new',
      items: [
        item('113-1', 4, 'Huîtres de Zélande n°3'),
        item('113-2', 2, 'Crevettes grises'),
        item('113-3', 1, 'Filet de sole', false, 'En filets'),
      ],
      totalPaidCents: 6850,
    },
    {
      id: 'o-111',
      number: 111,
      label: 'Mme Caron',
      contact: {
        name: 'Mme Caron',
        phone: '+32 495 77 21 03',
        email: 'm.caron@skynet.be',
      },
      channel: 'Click & Collect',
      pickupCode: '5 1 7 3',
      dueAt: due(59),
      stage: 'new',
      customerNote: 'Allergie aux fruits à coque',
      items: [
        item('111-1', 1, 'Paëlla royale'),
        item('111-2', 2, 'Croquettes de crevettes'),
        item('111-3', 1, 'Soupe de poissons 1 L'),
        item('111-4', 3, 'Filet de sole', false, 'En filets'),
        item('111-5', 2, 'Moules de Zélande', false, 'Nettoyées'),
        item('111-6', 1, 'Tarte au maton'),
      ],
      totalPaidCents: 9640,
    },
    {
      id: 'o-109',
      number: 109,
      label: '+32 493 55 18 02',
      contact: { phone: '+32 493 55 18 02' },
      channel: 'Click & Collect',
      pickupCode: '2 9 0 6',
      dueAt: due(19),
      stage: 'new',
      items: [
        item('109-1', 5, 'Moules de Zélande', false, 'Nettoyées'),
        item('109-2', 1, 'Bisque de homard'),
      ],
      totalPaidCents: 4290,
    },
    {
      id: 'o-114',
      number: 114,
      label: 'Mme Verhoeven',
      contact: {
        name: 'Mme Verhoeven',
        phone: '+32 476 21 08 44',
        email: 'm.verhoeven@telenet.be',
      },
      channel: 'Click & Collect',
      pickupCode: '8 2 4 0',
      dueAt: due(-11),
      stage: 'preparing',
      customerNote: 'Allergie aux crustacés',
      items: [
        item('114-1', 3, 'Gambas 4/6', false, 'Décortiquées'),
        item('114-2', 2, 'Caviar belge 50 g'),
        item('114-3', 2, 'Saumon fumé en plaque', true, 'Sans arêtes'),
        item('114-4', 3, 'Truites saumonées', true, 'En filets'),
        item('114-5', 1, 'Bisque de homard', true),
      ],
      totalPaidCents: 13020,
    },
    {
      id: 'o-107',
      number: 107,
      label: 'Traiteur Grimbergen',
      contact: { name: 'Traiteur Grimbergen', phone: '+32 2 270 11 40' },
      channel: 'Click & Collect',
      pickupCode: '3 3 5 8',
      dueAt: due(-26),
      stage: 'preparing',
      items: [
        item('107-1', 2, 'Tarte au maton'),
        item('107-2', 1, 'Paëlla royale'),
      ],
      totalPaidCents: 7480,
    },
    {
      id: 'o-115',
      number: 115,
      label: 'Mme Dejaegher',
      contact: {
        name: 'Mme Dejaegher',
        phone: '+32 478 63 20 17',
        email: 'c.dejaegher@proximus.be',
      },
      channel: 'Click & Collect',
      pickupCode: '6 0 4 4',
      dueAt: due(4),
      stage: 'preparing',
      items: [
        item('115-1', 2, 'Filet de sole', false, 'En filets'),
        item('115-2', 1, 'Soupe de poissons 1 L'),
      ],
      totalPaidCents: 5120,
    },
    {
      id: 'o-116',
      number: 116,
      label: 'Table 4',
      contact: {},
      channel: 'Sur place',
      pickupCode: '1 8 3 7',
      dueAt: due(29),
      stage: 'preparing',
      items: [item('116-1', 2, 'Croquettes de crevettes')],
      totalPaidCents: 3900,
    },
    {
      id: 'o-117',
      number: 117,
      label: '+32 486 12 44 70',
      contact: { phone: '+32 486 12 44 70' },
      channel: 'Click & Collect',
      pickupCode: '9 2 6 1',
      dueAt: due(49),
      stage: 'preparing',
      items: [
        item('117-1', 1, 'Gambas 4/6', false, 'Décortiquées'),
        item('117-2', 3, 'Huîtres de Zélande n°3'),
      ],
      totalPaidCents: 8760,
    },
    {
      id: 'o-108',
      number: 108,
      label: 'Mme Caron',
      contact: {
        name: 'Mme Caron',
        phone: '+32 495 77 21 03',
        email: 'm.caron@skynet.be',
      },
      channel: 'Click & Collect',
      pickupCode: '7 5 2 8',
      dueAt: due(14),
      stage: 'ready',
      items: [item('108-1', 1, 'Bisque de homard', true)],
      totalPaidCents: 2450,
    },
    {
      id: 'o-110',
      number: 110,
      label: 'Table 6',
      contact: {},
      channel: 'Sur place',
      pickupCode: '2 4 6 9',
      dueAt: due(44),
      stage: 'ready',
      items: [item('110-1', 2, 'Paëlla royale', true)],
      totalPaidCents: 5600,
    },
  ];
};

const HOUR = 60 * MINUTE;

// Des commandes déjà remises, aujourd'hui et la veille : ce qui est « déjà sorti ».
export const buildDeliveredSeed = (now: number): PdsOrder[] => {
  const start = new Date(now);
  start.setHours(0, 0, 0, 0);
  const at = (hour: number, dayOffset = 0) =>
    start.getTime() + hour * HOUR - dayOffset * 24 * HOUR;
  const handed = (
    number: number,
    label: string,
    dueAt: number,
    items: PdsOrderItem[],
  ): PdsOrder => ({
    id: `d-${number}`,
    number,
    label,
    contact: { name: label },
    channel: 'Click & Collect',
    pickupCode: '1 2 3 4',
    dueAt,
    stage: 'handed',
    items,
    totalPaidCents: 4200,
  });

  return [
    handed(109, 'M. Peeters', at(8), [
      item('109-1', 3, 'Truites saumonées'),
      item('109-2', 2, 'Saumon fumé en plaque'),
    ]),
    handed(110, 'Mme Janssens', at(9), [
      item('110-1', 1, 'Plateau de fruits de mer'),
    ]),
    handed(98, 'M. Claes', at(15, 1), [item('98-1', 2, 'Moules de Zélande')]),
    handed(99, 'Table 4', at(17, 1), [item('99-1', 1, 'Bisque de homard')]),
  ];
};
